import { render, staticRenderFns } from "./saldodeposito.vue?vue&type=template&id=0da12e1c&scoped=true"
import script from "./saldodeposito.vue?vue&type=script&lang=js"
export * from "./saldodeposito.vue?vue&type=script&lang=js"
import style0 from "./saldodeposito.vue?vue&type=style&index=0&id=0da12e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da12e1c",
  null
  
)

export default component.exports